exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".permission-list[data-v-332f57d0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.permission-list .permission-item[data-v-332f57d0] {\n  background: #018801;\n  color: #fff;\n  border-radius: 2px;\n  padding: 0 3px;\n  text-align: center;\n  margin: 2px;\n}\n.pagination-wrap[data-v-332f57d0] {\n  text-align: right;\n  margin-top: 20px;\n}\n", ""]);

// exports
